import { removeStyleTag, upsertStyleTag } from "../../domStyles";

const ROOT = document.documentElement;

const CLASS = "incluway-bg-custom";
const VAR = "--incluway-bg-color";
const STYLE_ID = "incluway-bg-color-style";

const EXCLUDE = "#incluway-widget-root";

export function setBackgroundColor(colorInput: unknown) {
  const color = String(colorInput ?? "").trim();

  if (!color) {
    disableBackgroundColor();
    return;
  }

  upsertStyleTag(
    STYLE_ID,
    `
html.${CLASS} body {
  background-color: var(${VAR}) !important;
}

/* page surfaces */
html.${CLASS} body :is(
  main, section, article, aside, header, footer, nav,
  div, form, fieldset, table, ul, ol, li
):not(${EXCLUDE}):not(${EXCLUDE} *) {
  background-color: var(${VAR}) !important;
}

/* ensure widget stays untouched */
html.${CLASS} ${EXCLUDE} {
  background: initial !important;
}
`.trim(),
  );

  ROOT.style.setProperty(VAR, color);
  ROOT.classList.add(CLASS);
}

export function disableBackgroundColor() {
  ROOT.classList.remove(CLASS);
  ROOT.style.removeProperty(VAR);
  removeStyleTag(STYLE_ID);
}
